export const SpaceCoverImageReader = Symbol('SpaceCoverImageReader');
